import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Grid from "@mui/material/Grid";
import { getSites } from "src/apis/complex";
import { useEffect } from "react";
import "./monitoring.css";
// Import the marker icon
import {
  redMarkerIcon,
  greenMarkerIcon,
  markerShadow,
} from "src/util/mapImages";
import { useNavigate, useRouteLoaderData, defer } from "react-router-dom";
import { useState } from "react";
import { useAlertContext } from "src/hooks/use-alert";
import MapWithDifferentLevels from "./mapsWithDifferentLevelTest";
import { checkSiteAlarms,determineSitesWithAlarms } from "src/util/utilFunctions";
const greenMarker = new L.Icon({
  iconUrl: greenMarkerIcon,
  iconRetinaUrl: greenMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const redMarker = new L.Icon({
  iconUrl: redMarkerIcon,
  iconRetinaUrl: redMarkerIcon,
  shadowUrl: markerShadow,
  iconSize: [27, 40],
  iconAnchor: [16, 32],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Define the locations and their details

function ZoomedOutMonitoring() {
  const alert = useAlertContext();
  var locations = [];
  const [locations_, setLocations_] = useState([]);
  const [powerItems, setPowerItems] = useState([]);
  const [siteAlarms, setSiteAlarms] = useState([]);
  const allSites = useRouteLoaderData("zoomMonitoring");

  const navigate = useNavigate();
  const handleMarkerClick = () => {
    navigate(`/dashboard/explore-complexes/level2`);
  };

  const handleSwitchViewClick = () => {
    navigate(`/dashboard/explore-complexes/complexListMode`);
  };

  const updateSites = async () => {
    await getSites().then((res) => {
      if (res && res.length > 0) {
        const itemsWithAlarms = checkSiteAlarms(res);
        const sitesWithAlarms = determineSitesWithAlarms(
          allSites.sites,
          itemsWithAlarms
        );
        locations = sitesWithAlarms;
        console.log(locations);
        setLocations_(locations);
      }
    });
  };

  useEffect(() => {
    if (alert.alarmPageUpdate) {
      const timeoutId = setTimeout(() => {
        updateSites();
      }, 900);

      alert.setAlarmPageUpdate(false);
    } 
  }, [alert.alarmPageUpdate]);
  useEffect(() => {
    if (allSites.sites && allSites.sites.length > 0) {
      const itemsWithAlarms = checkSiteAlarms(allSites.sites);
      const sitesWithAlarms = determineSitesWithAlarms(
        allSites.sites,
        itemsWithAlarms
      );
      locations = sitesWithAlarms;
      console.log(locations);
      setLocations_(locations);
    }
  }, [allSites]);

  return (
    <MapWithDifferentLevels
      headerTitle={"Level 1"}
      locations={locations_}
      zoomLevel={3}
      clickHandleMarker={handleMarkerClick}
      clickHandleButton={handleSwitchViewClick}
    />
  );
}

export default ZoomedOutMonitoring;

async function loadSites() {
  const response = await getSites();
  return response;
}

export async function loader({}) {
  return defer({
    sites: await loadSites(),
  });
}
